import { normalize } from 'normalizr';
import market from './entities/market';

export default (markets) => normalize(markets, [market]);
